import axios from "axios";


const clean = (obj) => {
  const out = {};
  Object.entries(obj || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null && String(v).trim() !== "") out[k] = v;
  });
  return out;
};

/* ── Province ───────────────────────────────────────────────────────────── */

const GetProvinceList = async () =>
  axios.get(`Region/LoadProvinceDetails`).then((response) => response);

const GetProvinceById = async (p_provinceCode) =>
  axios
    .get(`Region/LoadProvinceById`, { params: { p_provinceCode } })
    .then((response) => response);

const AddProvince = async ({ p_provinceName, p_status = 1 }) =>
  axios
    .post(`Region/AddProvince`, null, { params: clean({ p_provinceName, p_status }) })
    .then((response) => response);

/** Update — same endpoint, with the code present. */
const UpdateProvince = async ({ p_provinceCode, p_provinceName, p_status }) =>
  axios
    .post(`Region/AddProvince`, null, {
      params: clean({ p_provinceCode, p_provinceName, p_status }),
    })
    .then((response) => response);

/* ── District ───────────────────────────────────────────────────────────── */

const GetDistrictList = async () =>
  axios.get(`Region/LoadDistrictDetails`).then((response) => response);

const GetDistrictById = async (p_districtCode) =>
  axios
    .get(`Region/LoadDistrictDetailsById`, { params: { p_districtCode } })
    .then((response) => response);

const AddDistrict = async ({ p_districtProvinceCode, p_districtName, p_status = 1 }) =>
  axios
    .post(`Region/AddDistrictDetails`, null, {
      params: clean({ p_districtProvinceCode, p_districtName, p_status }),
    })
    .then((response) => response);

const UpdateDistrict = async ({
  p_districtCode,
  p_districtProvinceCode,
  p_districtName,
  p_status,
}) =>
  axios
    .post(`Region/AddDistrictDetails`, null, {
      params: clean({
        p_districtCode,
        p_districtProvinceCode,
        p_districtName,
        p_status,
      }),
    })
    .then((response) => response);


const GetElectorateList = async () =>
  axios.get(`Region/LoadElectorateDetails`).then((response) => response);

const GetElectorateById = async (p_electorateCod) =>
  axios
    .get(`Region/LoadElectorateDetailsById`, { params: { p_electorateCod } })
    .then((response) => response);

const AddElectorate = async ({
  p_electorateArea,
  p_electorateProvince,
  p_electorateDistrict,
  p_status = 1,
}) =>
  axios
    .post(`Region/AddLoadElectorateDetails`, null, {
      params: clean({ p_electorateArea, p_electorateProvince, p_electorateDistrict, p_status }),
    })
    .then((response) => response);

/** Update — same endpoint, with the electorate code present. */
const UpdateElectorate = async ({
  p_electorateCode,
  p_electorateArea,
  p_electorateProvince,
  p_electorateDistrict,
}) =>
  axios
    .post(`Region/AddLoadElectorateDetails`, null, {
      params: clean({
        p_electorateCode,
        p_electorateArea,
        p_electorateProvince,
        p_electorateDistrict,
      }),
    })
    .then((response) => response);



const GetPoliceStationList = async () =>
  axios.get(`Region/LoadPolicestationDetails`).then((response) => response);

const GetPoliceStationById = async (p_stationCode) =>
  axios
    .get(`Region/LoadPolicestationDetailsById`, { params: { p_stationCode } })
    .then((response) => response);

const AddPoliceStation = async ({
  p_stationName,
  p_stationProvinceCode,
  p_stationDistrictCode,
  p_stationElectorateCode,
  p_stationPDivisionCode,
  p_status = 1,
}) =>
  axios
    .post(`Region/AddLoadPolicestationDetails`, null, {
      params: clean({
        p_stationName,
        p_stationProvinceCode,
        p_stationDistrictCode,
        p_stationElectorateCode,
        p_stationPDivisionCode,
        p_status,
      }),
    })
    .then((response) => response);

/** Update — same endpoint, with the station code present. */
const UpdatePoliceStation = async ({
  p_stationCode,
  p_stationName,
  p_stationProvinceCode,
  p_stationDistrictCode,
  p_stationElectorateCode,
  p_stationPDivisionCode,
  p_status,
}) =>
  axios
    .post(`Region/AddLoadPolicestationDetails`, null, {
      params: clean({
        p_stationCode,
        p_stationName,
        p_stationProvinceCode,
        p_stationDistrictCode,
        p_stationElectorateCode,
        p_stationPDivisionCode,
        p_status,
      }),
    })
    .then((response) => response);

/* ── Grama Sewaka Division ──────────────────────────────────────────────────
 * Unlike the levels above, the code is typed by the user rather than allocated
 * by the backend, so it is sent on insert. Only list and add exist so far —
 * there is no by-id read or update endpoint yet.
 */

const GetGramaList = async () =>
  axios.get(`Region/GetAllGrama`).then((response) => response);

const AddGrama = async ({ p_GramasewakaCode, p_GramasewakaDivisionName }) => {
  const params = clean({ p_GramasewakaCode, p_GramasewakaDivisionName });
  try {
    return await axios.post(`Region/AddGrama`, null, { params });
  } catch (error) {
    // The other Region writes are [HttpPost], but this one was handed over as a
    // URL opened in a browser, so it may still be [HttpGet]. A verb mismatch
    // answers 404/405 — retry once as GET rather than fail the save.
    const code = error?.response?.status;
    if (code === 404 || code === 405) {
      return axios.get(`Region/AddGrama`, { params });
    }
    throw error;
  }
};

const regionService = {
  GetProvinceList,
  GetProvinceById,
  AddProvince,
  UpdateProvince,

  GetDistrictList,
  GetDistrictById,
  AddDistrict,
  UpdateDistrict,

  GetElectorateList,
  GetElectorateById,
  AddElectorate,
  UpdateElectorate,

  GetPoliceStationList,
  GetPoliceStationById,
  AddPoliceStation,
  UpdatePoliceStation,

  GetGramaList,
  AddGrama,
};

export default regionService;